module.exports = __webpack_public_path__ + "img/moi.bb5fd99b.jpg";